/* Zenith CRO — interactions for the custom product section (Gang v3 / Shrine).
   Operates on the Liquid-rendered DOM. All IDs are prefixed znt-. */
(function(){
  'use strict';
  var cfgMap = window.zntConfig || {};
  var CFG = cfgMap[Object.keys(cfgMap)[0]] || {variants:[], moneyFormat:'${{amount}}'};
  var VARIANTS = CFG.variants || [];
  var MONEY = CFG.moneyFormat || '${{amount}}';
  var ATC = CFG.atcLabel || 'Add to Cart';
  var SOLD = CFG.soldoutLabel || 'Sold out';
  var VERIFIED = CFG.verifiedLabel || 'Verified';

  function $(id){ return document.getElementById(id); }
  function q(sel, root){ return (root||document).querySelector(sel); }
  function qa(sel, root){ return [].slice.call((root||document).querySelectorAll(sel)); }

  /* ---------- money ---------- */
  function fmtMoney(cents){
    var value = (cents/100);
    function num(n, dec, ts, ds){
      dec = dec==null?2:dec; ts = ts||','; ds = ds||'.';
      var parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ts);
      return dec ? parts[0]+ds+parts[1] : parts[0];
    }
    return MONEY.replace(/\{\{\s*(\w+)\s*\}\}/g, function(_, name){
      switch(name){
        case 'amount': return num(value,2,',','.');
        case 'amount_no_decimals': return num(value,0,',','.');
        case 'amount_with_comma_separator': return num(value,2,'.',',');
        case 'amount_no_decimals_with_comma_separator': return num(value,0,'.',',');
        case 'amount_with_space_separator': return num(value,2,' ','.');
        case 'amount_no_decimals_with_space_separator': return num(value,0,' ','.');
        default: return num(value,2,',','.');
      }
    });
  }

  /* ---------- gallery ---------- */
  var curImg = 0;
  var thumbs = qa('#znt-thumbs img');
  function galSet(){ return qa('#znt-thumbs img'); }
  function showHero(src){
    var h=$('znt-hero');
    if(!h || !src) return;
    if(h.tagName!=='IMG') return; /* placeholder div when no images */
    if(h.getAttribute('src')===src) return;
    var h2=$('znt-hero2');
    if(h2){ h2.src=src; h2.classList.add('show'); }
    var img=new Image();
    img.onload=function(){ h.src=src; if(h2) setTimeout(function(){ h2.classList.remove('show'); },40); };
    img.onerror=function(){ if(h2) h2.classList.remove('show'); };
    img.src=src;
  }
  window.zntSetImg = function(i){
    var t=galSet(); if(!t.length) return; curImg=(i+t.length)%t.length;
    var full=t[curImg].getAttribute('data-full')||t[curImg].src;
    showHero(full);
    t.forEach(function(im,k){ im.classList.toggle('on', k===curImg); });
    if(t[curImg] && t[curImg].scrollIntoView){ try{ t[curImg].scrollIntoView({inline:'center', block:'nearest', behavior:'smooth'}); }catch(e){} }
    var gc=$('znt-gcount'); if(gc) gc.textContent=(curImg+1)+' / '+t.length;
  };
  window.zntGalStep = function(d){ var t=galSet(); if(!t.length) return; window.zntSetImg((curImg+d+t.length)%t.length); };

  /* lightbox */
  var lb=null, lbIdx=0;
  function buildLightbox(){
    lb=document.createElement('div'); lb.className='lightbox'; lb.id='znt-lightbox';
    lb.innerHTML='<button class="lb-close" aria-label="Close">Close<span class="x">✕</span></button>'+
      '<button class="lb-nav lb-prev" aria-label="Previous">‹</button>'+
      '<img class="lb-img" alt="zoom">'+
      '<button class="lb-nav lb-next" aria-label="Next">›</button>'+
      '<div class="lb-count"></div>';
    (document.querySelector('.znt')||document.body).appendChild(lb);
    lb.querySelector('.lb-close').onclick=closeLB;
    lb.querySelector('.lb-prev').onclick=function(e){e.stopPropagation();lbStep(-1);};
    lb.querySelector('.lb-next').onclick=function(e){e.stopPropagation();lbStep(1);};
    lb.querySelector('.lb-img').onclick=function(e){e.stopPropagation();lbStep(1);};
    lb.addEventListener('click', function(e){ if(e.target===lb) closeLB(); });
    addEventListener('keydown', function(e){ if(!lb.classList.contains('open'))return; if(e.key==='Escape')closeLB(); else if(e.key==='ArrowLeft')lbStep(-1); else if(e.key==='ArrowRight')lbStep(1); });
  }
  function openLB(i){ if(!lb) buildLightbox(); var t=galSet(); lbIdx=i; lb.querySelector('.lb-img').src=t[i].getAttribute('data-full')||t[i].src; lb.querySelector('.lb-count').textContent=(i+1)+' / '+t.length; lb.classList.add('open'); document.documentElement.style.overflow='hidden'; }
  function lbStep(d){ var t=galSet(); lbIdx=(lbIdx+d+t.length)%t.length; lb.querySelector('.lb-img').src=t[lbIdx].getAttribute('data-full')||t[lbIdx].src; lb.querySelector('.lb-count').textContent=(lbIdx+1)+' / '+t.length; }
  function closeLB(){ if(lb){ lb.classList.remove('open'); document.documentElement.style.overflow=''; } }

  /* swipe (drag-follow) + tap-to-zoom */
  var galSwiped=false;
  window.zntHeroTap=function(){ if(galSwiped){galSwiped=false;return;} openLB(curImg); };
  (function(){
    var gal=$('znt-gallery'); if(!gal) return; var hero=$('znt-hero'); var x0=null,y0=null,drag=false;
    gal.addEventListener('touchstart', function(e){ galSwiped=false; var t=e.changedTouches[0]; x0=t.clientX; y0=t.clientY; drag=false; if(hero) hero.style.transition='none'; }, {passive:true});
    gal.addEventListener('touchmove', function(e){ if(x0==null)return; var t=e.touches[0]; var dx=t.clientX-x0, dy=t.clientY-y0;
      if(!drag){ if(Math.abs(dx)>8 && Math.abs(dx)>Math.abs(dy)){ drag=true; } else if(Math.abs(dy)>10){ x0=null; if(hero) hero.style.transition=''; return; } }
      if(drag && hero){ e.preventDefault(); hero.style.transform='translateX('+(dx*0.55)+'px)'; } }, {passive:false});
    gal.addEventListener('touchend', function(e){ if(x0==null)return; var t=e.changedTouches[0]; var dx=t.clientX-x0;
      if(hero){ hero.style.transition='transform .32s cubic-bezier(.2,.7,.2,1)'; hero.style.transform='translateX(0)'; }
      if(drag){ galSwiped=true; if(Math.abs(dx)>48) window.zntGalStep(dx<0?1:-1); }
      x0=null; drag=false; setTimeout(function(){ if(hero){hero.style.transition='';hero.style.transform='';} }, 340); });
  })();

  /* ---------- variants ---------- */
  var selected = [];
  (function initSel(){
    var first = VARIANTS.filter(function(v){return v.available;})[0] || VARIANTS[0];
    if(first){ selected = first.options.slice(); }
  })();
  function currentVariant(){
    return VARIANTS.filter(function(v){
      return v.options.every(function(o,i){ return o===selected[i]; });
    })[0];
  }
  function availableFor(optIndex, value){
    var test = selected.slice(); test[optIndex]=value;
    return VARIANTS.some(function(v){ return v.available && v.options.every(function(o,i){ return o===test[i]; }); });
  }
  /* option indices (which option is Color / which is Size) from the rendered DOM */
  var COLOR_IDX=-1, SIZE_IDX=-1;
  (function(){
    var sw=q('.znt .sw'); if(sw) COLOR_IDX=+sw.getAttribute('data-opt')-1;
    var sz=q('.znt .sz'); if(sz) SIZE_IDX=+sz.getAttribute('data-opt')-1;
  })();
  /* per-color size availability map, e.g. Black has no 2XL (from section setting color_sizes) */
  var COLORSIZES=null;
  (function(){
    var raw=CFG.colorSizes; if(!raw) return;
    var map={};
    String(raw).split(/\r?\n/).forEach(function(line){
      var p=line.split(':'); if(p.length<2) return;
      var color=p[0].trim().toLowerCase();
      var sizes=p.slice(1).join(':').split(',').map(function(s){return s.trim();}).filter(Boolean);
      if(color && sizes.length) map[color]=sizes;
    });
    if(Object.keys(map).length) COLORSIZES=map;
  })();
  function allowedSizes(colorVal){
    if(COLORSIZES){ var a=COLORSIZES[String(colorVal||'').toLowerCase()]; if(a) return a; }
    return null;
  }
  function sizeAllowed(sizeVal){
    var a = allowedSizes(COLOR_IDX>=0 ? selected[COLOR_IDX] : null);
    if(a) return a.indexOf(sizeVal)>=0;
    return availableFor(SIZE_IDX>=0?SIZE_IDX:0, sizeVal);
  }
  window.zntSelectOpt = function(position, el){
    var idx = position-1;
    var val = el.getAttribute('data-value');
    if(el.classList.contains('oos')) return;
    selected[idx] = val;
    // choosing a color whose current size isn't offered → jump to that color's first offered size
    if(idx===COLOR_IDX && SIZE_IDX>=0 && !sizeAllowed(selected[SIZE_IDX])){
      var a=allowedSizes(val); if(a && a.length) selected[SIZE_IDX]=a[0];
    }
    // keep a real, available Shopify variant selected (for price / id / add-to-cart)
    var v = currentVariant();
    if(!v || !v.available){
      var alt = VARIANTS.filter(function(x){ return x.available && x.options[idx]===val && (SIZE_IDX<0 || sizeAllowed(x.options[SIZE_IDX])); })[0]
             || VARIANTS.filter(function(x){ return x.available && x.options[idx]===val; })[0];
      if(alt) selected = alt.options.slice();
    }
    syncUI();
  };
  function syncUI(){
    // active states
    qa('.znt .sw').forEach(function(sw){ var i=+sw.getAttribute('data-opt')-1; sw.classList.toggle('on', sw.getAttribute('data-value')===selected[i]); });
    qa('.znt .sz').forEach(function(sz){ var i=+sz.getAttribute('data-opt')-1; var val=sz.getAttribute('data-value');
      sz.classList.toggle('on', val===selected[i]);
      var ok=sizeAllowed(val); sz.classList.toggle('oos', !ok);
    });
    // color label
    qa('.znt .znt-optlabel').forEach(function(lbl){ var pos=+lbl.getAttribute('data-for'); lbl.textContent=selected[pos-1]; });
    var v=currentVariant();
    var priceEl=$('znt-price'), wasEl=$('znt-was'), idEl=$('znt-variant-id'), addBtn=$('znt-add');
    if(v){
      if(idEl) idEl.value=v.id;
      if(priceEl) priceEl.textContent=fmtMoney(v.price);
      if(wasEl){ if(v.compare_at_price>v.price){ wasEl.textContent=fmtMoney(v.compare_at_price); wasEl.style.display=''; } else { wasEl.style.display='none'; } }
      var st=$('znt-stPrice'); if(st) st.textContent=fmtMoney(v.price);
      var meta=$('znt-stMeta'); if(meta) meta.textContent=v.title;
      var sti=$('znt-stImg'); if(sti && v.featured_image && v.featured_image.src){ var _su=v.featured_image.src; _su += (_su.indexOf('?')>-1?'&':'?')+'width=90'; sti.src=_su; }
      if(addBtn){ var l=addBtn.querySelector('.lbl'); addBtn.disabled=!v.available; if(l&&!addBtn.classList.contains('pop')) l.textContent=v.available?ATC:SOLD; }
      if(v.featured_image && v.featured_image.id){
        var t=galSet(), idx=-1;
        for(var k=0;k<t.length;k++){ if(+t[k].getAttribute('data-imgid')===v.featured_image.id){ idx=k; break; } }
        if(idx>=0){ window.zntSetImg(idx); }
        else if(v.featured_image.src){ var _u=v.featured_image.src; _u += (_u.indexOf('?')>-1?'&':'?')+'width=1100'; showHero(_u); }
      }
    }
    showStock();
  }

  /* ---------- per-size live stock counter (fake-scarcity; random 100–200, ticks down, never 0) ---------- */
  var STOCK_KEY='znt_stock_v2_'+(CFG.sectionId||'x');
  var STOCK_FLOOR=8;
  var STOCK_MIN=+CFG.stockMin||100, STOCK_MAX=+CFG.stockMax||200;
  if(STOCK_MAX<STOCK_MIN) STOCK_MAX=STOCK_MIN;
  var stockStore={};
  try{ stockStore=JSON.parse(localStorage.getItem(STOCK_KEY))||{}; }catch(e){ stockStore={}; }
  function saveStock(){ try{ localStorage.setItem(STOCK_KEY, JSON.stringify(stockStore)); }catch(e){} }
  function stockKeyFor(){
    var parts=[];
    if(COLOR_IDX>=0) parts.push(selected[COLOR_IDX]);
    if(SIZE_IDX>=0) parts.push(selected[SIZE_IDX]);
    return parts.join('|').toLowerCase();
  }
  function ensureStock(k){
    if(!k) return null;
    if(typeof stockStore[k]!=='number'){ stockStore[k]=STOCK_MIN+Math.floor(Math.random()*(STOCK_MAX-STOCK_MIN+1)); saveStock(); }
    return stockStore[k];
  }
  function showStock(){
    var el=$('znt-instock'); if(!el) return;
    if(SIZE_IDX>=0 && !sizeAllowed(selected[SIZE_IDX])){ el.style.display='none'; return; }
    el.style.display='';
    var n=ensureStock(stockKeyFor());
    var nEl=$('znt-stockN'); if(nEl && n!=null) nEl.textContent=n;
    var v=currentVariant(), szEl=$('znt-stockSize'); if(szEl && v) szEl.textContent=v.title;
  }
  (function(){
    var slow=function(){ return 25000+Math.floor(Math.random()*50000); }; /* 25–75s */
    var fast=function(){ return 9000+Math.floor(Math.random()*8000); };    /* 9–17s (one gentle early nudge) */
    var drop=function(){ return 1+Math.floor(Math.random()*2); };          /* 1–2 (gentle for small counts) */
    var quick=1;
    function pulse(){ var nEl=$('znt-stockN'); if(nEl){ nEl.classList.remove('pulse'); void nEl.offsetWidth; nEl.classList.add('pulse'); } }
    function tick(){
      setTimeout(function(){
        var k=stockKeyFor();
        if(k && typeof stockStore[k]==='number' && stockStore[k]>STOCK_FLOOR){
          stockStore[k]=Math.max(STOCK_FLOOR, stockStore[k]-drop());
          saveStock(); showStock(); pulse();
        }
        if(quick>0) quick--;
        tick();
      }, quick>0?fast():slow());
    }
    tick();
  })();

  /* ---------- add to cart ---------- */
  /* The form is wrapped in the theme's <product-form> element, so the theme's own
     JS handles AJAX add + opening the native cart drawer. We do NOT intercept the submit
     (that avoids the page-freeze). We only keep the hidden variant id in sync (see syncUI). */

  /* ---------- quantity stepper (input name="quantity" is submitted with the form) ---------- */
  var QTY_MAX=99;
  function clampQty(n){ n=parseInt(n,10); if(isNaN(n)||n<1) n=1; if(n>QTY_MAX) n=QTY_MAX; return n; }
  window.zntQty=function(d){ var el=$('znt-qty'); if(!el) return; el.value=clampQty((parseInt(el.value,10)||1)+d); };
  (function(){ var el=$('znt-qty'); if(!el) return;
    el.addEventListener('change', function(){ el.value=clampQty(el.value); });
    el.addEventListener('blur', function(){ el.value=clampQty(el.value); });
  })();

  /* ---------- lookbook arrows ---------- */
  window.zntLookScroll=function(d){ var el=$('znt-lookGrid'); if(!el)return; var fig=el.querySelector('figure'); var step=fig?fig.getBoundingClientRect().width+16:Math.round(el.clientWidth*0.8); el.scrollBy({left:d*step, behavior:'smooth'}); };

  /* ---------- AOV: "you may also like" carousel scroll ---------- */
  window.zntRecScroll=function(d){ var el=$('znt-recGrid'); if(!el)return; var card=el.querySelector('.rec'); var step=card?card.getBoundingClientRect().width+16:Math.round(el.clientWidth*0.8); el.scrollBy({left:d*step, behavior:'smooth'}); };

  /* ---------- AOV: launch-deal add-on variant sync ---------- */
  (function(){
    var DEAL = CFG.dealVariants; if(!DEAL || !DEAL.length) return;
    window.zntDealSync = function(){
      var sels = qa('.znt .deal-sel');
      var chosen = sels.map(function(s){ return s.value; });
      var v = DEAL.filter(function(vv){
        return chosen.every(function(o,i){ return vv.options[i]===o; });
      })[0] || DEAL.filter(function(vv){ return vv.available; })[0];
      if(!v) return;
      var idEl=$('znt-deal-id'), pEl=$('znt-dealPrice'), wEl=$('znt-dealWas'), btn=$('znt-dealAdd');
      if(idEl) idEl.value=v.id;
      if(pEl) pEl.textContent = (CFG.dealPrice && CFG.dealPrice.length) ? CFG.dealPrice : fmtMoney(v.price);
      if(wEl){ if(CFG.dealComparePrice && CFG.dealComparePrice.length){ wEl.textContent=CFG.dealComparePrice; wEl.style.display=''; } else if(v.compare_at_price>v.price){ wEl.textContent=fmtMoney(v.compare_at_price); wEl.style.display=''; } else { wEl.style.display='none'; } }
      if(btn){ var l=btn.querySelector('.lbl'); btn.disabled=!v.available; if(l) l.textContent=v.available?ATC:SOLD; }
    };
  })();

  /* ---------- scroll to reviews (from the "N reviews" link) ---------- */
  window.zntScrollReviews=function(){ var el=$('znt-reviews'); if(el) el.scrollIntoView({behavior:'smooth', block:'start'}); };

  /* ---------- size guide: inline accordion table + inch/cm toggle ---------- */
  var SZUNIT='in';
  function parseSizeRows(){
    return String(CFG.sizeRows||'').split(/\r?\n/).map(function(l){return l.trim();}).filter(Boolean)
      .map(function(l){ return l.split(',').map(function(c){return c.trim();}); });
  }
  function renderSizeTable(){
    var tab=$('znt-sztab'); if(!tab) return;
    var rows=parseSizeRows(); if(!rows.length){ tab.innerHTML=''; return; }
    var u=SZUNIT;
    function num(v){ var n=parseFloat(v); return isNaN(n)?null:n; }
    function cv(v){ var n=num(v); if(n==null) return v; return u==='in' ? (Math.round(n*10)/10) : Math.round(n*2.54); }
    function wv(w){ if(u==='in') return w; return String(w).split(/[–-]/).map(function(x){ var n=num(x); return n==null?x:Math.round(n*2.54); }).join('–'); }
    var SC=(CFG.sizeCols&&CFG.sizeCols.length===4)?CFG.sizeCols:['Size','Length','Hip','Waist'];
    var html='<thead><tr><th>'+SC[0]+'</th><th>'+SC[1]+' ('+u+')</th><th>'+SC[2]+' ('+u+')</th><th>'+SC[3]+' ('+u+')</th></tr></thead><tbody>';
    html+=rows.map(function(r){ return '<tr><td>'+(r[0]||'')+'</td><td>'+cv(r[1])+'</td><td>'+cv(r[2])+'</td><td>'+wv(r[3]||'')+'</td></tr>'; }).join('');
    tab.innerHTML=html+'</tbody>';
  }
  window.zntSetUnit=function(u){
    SZUNIT=u;
    var i=$('znt-uIn'), c=$('znt-uCm'); if(i) i.classList.toggle('on',u==='in'); if(c) c.classList.toggle('on',u==='cm');
    renderSizeTable();
    var p=q('#znt-acSize .panel'); if(p && p.acc_reheight) p.acc_reheight();
  };
  window.zntOpenSize=function(){
    var d=$('znt-acSize'); if(!d) return;
    if(!d.classList.contains('acc-open')){ var sum=d.querySelector('summary'); if(sum) sum.click(); }
    d.scrollIntoView({behavior:'smooth', block:'start'});
  };
  renderSizeTable();

  /* ---------- review modal ---------- */
  var rmodal=null;
  function buildReviewModal(){
    rmodal=document.createElement('div'); rmodal.className='rmodal'; rmodal.id='znt-rmodal';
    rmodal.innerHTML='<div class="rmodal-box" id="znt-rmodalBox"><button class="rmodal-close" aria-label="Close">&times;</button>'+
      '<div class="rmodal-photo" id="znt-rmPhotoWrap"><img id="znt-rmPhoto" alt="Customer photo"></div>'+
      '<div class="rmodal-side"><div class="rmodal-head"><span class="avatar" id="znt-rmAvatar"></span><span class="rev-meta"><b id="znt-rmName"></b><span class="vf" id="znt-rmVf"></span></span></div>'+
      '<div class="stars" id="znt-rmStars"></div><span class="rev-var" id="znt-rmVar"></span><p class="rmodal-text" id="znt-rmText"></p></div></div>';
    (document.querySelector('.znt')||document.body).appendChild(rmodal);
    rmodal.querySelector('.rmodal-close').onclick=zntCloseReview;
    rmodal.addEventListener('click', function(e){ if(e.target===rmodal) zntCloseReview(); });
    addEventListener('keydown', function(e){ if(e.key==='Escape' && rmodal.classList.contains('open')) zntCloseReview(); });
  }
  function stars(n){ var s=''; for(var i=0;i<5;i++) s+= i<n?'★':'<span class="dim">★</span>'; return s; }
  window.zntOpenReview=function(el){
    if(!rmodal) buildReviewModal();
    var photo=el.getAttribute('data-photo');
    var box=$('znt-rmodalBox'), wrap=$('znt-rmPhotoWrap');
    if(photo){ $('znt-rmPhoto').src=photo; wrap.style.display=''; box.classList.remove('no-photo'); } else { wrap.style.display='none'; box.classList.add('no-photo'); }
    var name=el.getAttribute('data-name')||'';
    $('znt-rmAvatar').textContent=(name[0]||'').toUpperCase();
    $('znt-rmName').textContent=name;
    $('znt-rmVf').innerHTML='<svg viewBox="0 0 24 24"><path d="M20 6L9 17l-5-5"/></svg>'+VERIFIED+' · '+(el.getAttribute('data-date')||'');
    $('znt-rmStars').innerHTML=stars(+(el.getAttribute('data-stars')||5));
    var vr=$('znt-rmVar'), variant=el.getAttribute('data-variant');
    if(variant){ vr.textContent=variant; vr.style.display=''; } else { vr.style.display='none'; }
    $('znt-rmText').textContent='“'+(el.getAttribute('data-text')||'')+'”';
    rmodal.classList.add('open'); document.documentElement.style.overflow='hidden';
  };
  window.zntCloseReview=function(){ if(rmodal){ rmodal.classList.remove('open'); document.documentElement.style.overflow=''; } };

  /* ---------- bento slideshows (random-direction slide: L/R + up/down) ---------- */
  (function(){ var shows=qa('.znt .bt.slideshow');
    var DIRS=[
      {inFrom:'translateX(100%)',  out:'translateX(-100%)'},  /* new from right, old exits left  */
      {inFrom:'translateX(-100%)', out:'translateX(100%)'},   /* new from left,  old exits right */
      {inFrom:'translateY(100%)',  out:'translateY(-100%)'},  /* new from below, old exits up    */
      {inFrom:'translateY(-100%)', out:'translateY(100%)'}    /* new from above, old exits down  */
    ];
    shows.forEach(function(fig,fi){
      var imgs=qa('img', fig); if(imgs.length<2) return; var idx=0; var last=-1;
      imgs.forEach(function(im,k){ im.classList.toggle('on', k===0); im.style.transform = k===0 ? 'translate(0,0)' : 'translateX(100%)'; });
      setInterval(function(){
        var di; do { di=Math.floor(Math.random()*DIRS.length); } while(DIRS.length>1 && di===last); last=di;
        var d=DIRS[di];
        var cur=imgs[idx], next=imgs[(idx+1)%imgs.length];
        cur.style.transition=''; cur.style.transform=d.out; cur.classList.remove('on');       /* old slides out */
        next.style.transition='none'; next.style.transform=d.inFrom; void next.offsetWidth;    /* park new off the opposite edge */
        next.style.transition=''; next.style.transform='translate(0,0)'; next.classList.add('on'); /* new slides in */
        idx=(idx+1)%imgs.length;
      }, 3600+fi*700);
    });
  })();

  /* ---------- sticky ATC ---------- */
  (function(){ var cta=q('.znt .cta'), sticky=$('znt-sticky'); if(!cta||!sticky)return;
    addEventListener('scroll', function(){ sticky.classList.toggle('show', cta.getBoundingClientRect().bottom<0); }); })();

  /* ---------- accordions (smooth); layout reads are batched (all offsetHeight reads together) to avoid a forced reflow per accordion on load ---------- */
  (function(){
    var items = qa('.znt details').map(function(d){
      var sum=d.querySelector('summary'), pan=d.querySelector('.panel'); if(!pan) return null;
      var pad=pan.querySelector('.panel-pad'); if(!pad){ pad=document.createElement('div'); pad.className='panel-pad'; while(pan.firstChild) pad.appendChild(pan.firstChild); pan.appendChild(pad); }
      var contentH=function(){ return pad.offsetHeight; };
      pan.acc_reheight=function(){ if(d.classList.contains('acc-open')) pan.style.height=contentH()+'px'; };
      var startOpen=d.open; d.open=true;
      sum.addEventListener('click', function(e){ e.preventDefault();
        if(d.classList.contains('acc-open')){ pan.style.height=contentH()+'px'; void pan.offsetHeight; d.classList.remove('acc-open'); pan.style.height='0px'; }
        else { d.classList.add('acc-open'); pan.style.height='0px'; void pan.offsetHeight; pan.style.height=contentH()+'px'; } });
      return { d:d, pan:pan, contentH:contentH, startOpen:startOpen };
    }).filter(Boolean);
    var heights = items.map(function(it){ return it.startOpen ? it.contentH() : 0; }); /* read phase: one reflow for all */
    items.forEach(function(it,i){ if(it.startOpen){ it.d.classList.add('acc-open'); it.pan.style.height=heights[i]+'px'; } else { it.pan.style.height='0px'; } }); /* write phase */
  })();

  /* ---------- estimated arrival dates ---------- */
  (function(){ function ord(d){return d+((d%10==1&&d!=11)?'st':(d%10==2&&d!=12)?'nd':(d%10==3&&d!=13)?'rd':'th');}
    var M=['Jan','Feb','Mar','Apr','May','Jun','Jul','Aug','Sep','Oct','Nov','Dec'];
    function f(dt){return M[dt.getMonth()]+' '+ord(dt.getDate());}
    var n=new Date(); var disp=new Date(n); disp.setDate(n.getDate()+3); var a=new Date(n); a.setDate(n.getDate()+9); var b=new Date(n); b.setDate(n.getDate()+11);
    var d1=$('znt-trkD1'),d2=$('znt-trkD2'),d3=$('znt-trkD3');
    if(d1)d1.textContent=f(n); if(d2)d2.textContent=f(disp); if(d3)d3.textContent=f(a)+' – '+(a.getMonth()===b.getMonth()?ord(b.getDate()):f(b)); })();

  /* ---------- band video: lazy — only load & play once it scrolls into view (saves it from downloading on initial page load) ---------- */
  (function(){ var bv=q('.znt .band video'); if(!bv)return; bv.muted=true;
    if('IntersectionObserver' in window){ new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ bv.play&&bv.play().catch(function(){}); } else { bv.pause&&bv.pause(); } });},{threshold:.15, rootMargin:'200px 0px'}).observe(bv); }
    else { bv.play&&bv.play().catch(function(){}); } })();

  /* ---------- scroll reveal ---------- */
  (function(){ var els=qa('.znt .fullsec, .znt .band'); els.forEach(function(e){e.classList.add('reveal');});
    if(!('IntersectionObserver' in window)){ els.forEach(function(e){e.classList.add('in');}); return; }
    var io=new IntersectionObserver(function(es){es.forEach(function(e){ if(e.isIntersecting){ e.target.classList.add('in'); io.unobserve(e.target); } });},{threshold:.1, rootMargin:'0px 0px -8% 0px'});
    els.forEach(function(e){io.observe(e);}); setTimeout(function(){els.forEach(function(e){e.classList.add('in');});},2600); })();

  /* ---------- review pagination (3 per page) ---------- */
  (function(){ var grid=$('znt-revGrid'); if(!grid) return;
    var cards=qa('.rev', grid); var per=3; var page=0; var total=Math.max(1, Math.ceil(cards.length/per));
    var ind=$('znt-revInd'), prev=$('znt-revPrev'), next=$('znt-revNext'), pager=q('.znt .revpage');
    if(cards.length<=per && pager){ pager.style.display='none'; return; }
    function render(){ page=Math.max(0,Math.min(page,total-1));
      cards.forEach(function(c,i){ c.style.display=(i>=page*per && i<page*per+per)?'':'none'; });
      if(ind) ind.textContent=(page+1)+' / '+total;
      if(prev) prev.disabled=page===0;
      if(next) next.disabled=page===total-1;
    }
    if(prev) prev.onclick=function(){ page--; render(); grid.scrollIntoView({behavior:'smooth', block:'nearest'}); };
    if(next) next.onclick=function(){ page++; render(); grid.scrollIntoView({behavior:'smooth', block:'nearest'}); };
    render();
  })();

  /* init variant UI + gallery */
  syncUI();
  window.zntSetImg(0);
})();
